import { render, staticRenderFns } from "./InputCabang.vue?vue&type=template&id=c1febd88&"
import script from "./InputCabang.vue?vue&type=script&lang=js&"
export * from "./InputCabang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports